import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveComponentModule } from '@ngrx/component';
import { ButtonModule } from 'primeng/button';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

import { PageWithHeaderComponent } from './page-with-header.component';

@NgModule({
	imports: [
		CommonModule,
		ProgressSpinnerModule,
		ButtonModule,
		ReactiveComponentModule,
	],
	declarations: [PageWithHeaderComponent],
	exports: [PageWithHeaderComponent],
})
export class PageWithHeaderModule {}
